/*
 * JavaScript
 */

// ES6 import syntax || const main = require('./js.main.js')

import { utils } from './js/utils.js';
import { main } from './js/main.js';
import { navigation } from './js/navigation.js';
import { } from '../node_modules/fastclick';
import { form } from './js/form.js';

import { community } from './js/community.js';
import { drawer } from './js/drawer.js';
import { map } from './js/map.js';

document.addEventListener("DOMContentLoaded", function (event) {

	main.init();
	navigation.init();
	community.init();
	drawer.init();
	map.init();
	form.init();

});

if (module.hot) {

	module.hot.dispose(function () {
		// module is about to be replaced
		window.location.reload();
	});

	module.hot.accept(function () {
		// module or one of its dependencies was just updated
	});

}

/*
 * SCSS
 */
import './sass/index.scss';